import React, { useEffect } from 'react';

import { FCC } from '@/utils/types';

interface WithPageTitleProps {
  title: string;
  scope?: string;
}

export const WithPageTitle: FCC<WithPageTitleProps> = ({ title, scope, children }) => {
  useEffect(() => {
    document.title = `${title} ${scope ? `| ${scope}` : ''} | Tome`;
  }, [title, scope]);
  return <>{children}</>;
};
